import { render, staticRenderFns } from "./pjnoticeFile.vue?vue&type=template&id=7b32ce46&scoped=true"
import script from "./pjnoticeFile.vue?vue&type=script&lang=js"
export * from "./pjnoticeFile.vue?vue&type=script&lang=js"
import style0 from "./pjnoticeFile.vue?vue&type=style&index=0&id=7b32ce46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32ce46",
  null
  
)

export default component.exports